import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledNavBar = styled.nav`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 70px;
	padding: 0 30px;
	background-color: ${({ theme }) => theme.colors.background};
	border: 1px solid ${({ theme }) => theme.colors.separator};
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
	color: #ffffff;
`;

export const StyledNavigation = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	height: 100%;
`;

export const StyledNavItemContainer = styled.ul`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
`;

export const StyledNavItem = styled.li`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	gap: 20px;
	color: ${({ theme }) => theme.colors.text};
	font-weight: ${({ $isActive }) => ($isActive ? 'bold' : 'normal')};
	cursor: pointer;
	margin-right: 10px;
	&:hover {
		font-weight: bold;
	}
	& > a {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		color: ${({ theme }) => theme.colors.text};
		&:visited {
			color: ${({ theme }) => theme.colors.text};
		}
	}
`;

export const StyledAvatarContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	height: 100%;
	position: relative;
`;

export const StyledAvatar = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.primary};
	color: #ffffff;
	letter-spacing: 1px;
	font-size: 20px;
	font-weight: 700;
	margin-right: 10px;
	align-content: center;
	cursor: pointer;
`;

export const StyledActionList = styled.ul`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	position: absolute;
	top: 90%;
	right: 10px;
	width: 200px;
	background-color: ${({ theme }) => theme.colors.background};
	color: ${({ theme }) => theme.colors.text};
	border: 1px solid #e3e3e3;
	border-radius: 5px;
	padding: 10px;
	visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
	opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
	transition: visibility 0.3s, opacity 0.3s linear;
	z-index: 1001;
	& > li {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 40px;
		padding: 0 10px;
		cursor: pointer;
		color: ${({ theme }) => theme.colors.text};
		&:hover {
			font-weight: bold;
			& > svg {
				color: #000000;
			}
		}
	}
	&::after {
		content: '';
		position: absolute;
		top: -10px;
		right: 10px;
		width: 0;
		height: 0;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-bottom: 10px solid ${({ theme }) => theme.colors.primary};
	}
`;

export const StyledContainerFilter = styled.div`
	width: 230px !important;
	display: flex;
	height: inherit;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	padding: 10px;
	font-size: 18px;
	z-index: 10000;
	& > .title {
		font-size: 23px;
		font-weight: bold;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		color: ${({ theme }) => theme.colors.primary};
	}
	& > .actions {
		display: flex;
		justify-content: space-between;
		width: 100%;
		& > .action {
			&--primary {
				font-size: 20px;
				font-weight: bold;
				color: ${({ theme }) => theme.colors.primary};
			}
		}
	}
`;

export const StyledRefresh = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	margin-right: 10px;
	background-color: ${({ theme }) => theme.colors.primary};
	color: #ffffff;
	align-content: center;
	padding: 5px;
	cursor: pointer;
`;
